module.exports = __webpack_public_path__ + "img/keyboard_backspace.84a0082c.svg";